import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  loaderWrapper: {
    width: '100%',
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  buttonsContainer: {
    display: 'flex',
    justifyContent: 'end',
    flexDirection: 'row',
    marginTop: 'auto',
    width: '100%',
    gap: '10px',
  },
  dialogBody: {
    width: '600px',
    height: '700px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflow: 'hidden',
    padding: '15px 15px',
    boxSizing: 'border-box',
    borderTop: '1px solid lightgray',
  },
  dialogBodyRewest: {
    width: '900px',
    height: '700px',
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflow: 'hidden',
    padding: '15px 15px',
    boxSizing: 'border-box',
    borderTop: '1px solid lightgray',
  },
  templatesList: {
    gap: '10px',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: '10px',
    boxSizing: 'border-box',
    overflowY: 'auto',
  },
  template: {
    border: '1px solid lightgray',
    display: 'flex',
    padding: '10px 15px',
    boxShadow: 'border-box',
    borderRadius: '5px',
    flexDirection: 'row',
    cursor: 'pointer',
    transition: 'all 0.3s',
    '&:hover': {
      border: `1px solid ${theme.palette.primary.main}`,
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflow: 'hidden',
    height: '100%',
  },
  templateBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    overflowY: 'auto',
    padding: '10px 5px',
    boxSizing: 'border-box',
    height: '100%',
  },
  closeButton: {
    height: '24px',
  },
  rewestFullScreenContainer: {
    width: '100%',
    height: 'calc(100vh - 64px)', // Subtract dialog title height
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    padding: 0,
    boxSizing: 'border-box',
    '& > div': {
      width: '100%',
      height: '100%',
      minHeight: '100%',
      marginTop: 0,
      borderRadius: 0,
      border: 'none',
    },
    '& iframe': {
      width: '100%',
      height: '100%',
      minHeight: '100%',
    },
    '& [class*="loaderContainer"]': {
      height: '100%',
      minHeight: '100%',
    },
  },
  rewestDialog: {
    '& .MuiDialog-container': {
      alignItems: 'stretch',
    },
    '& .MuiPaper-root': {
      margin: 0,
      width: '100%',
      height: '100%',
      maxWidth: '100%',
      maxHeight: '100%',
      borderRadius: 0,
    },
  },
  regularDialog: {
    '& .MuiDialog-container': {
      '& .MuiPaper-root': {
        width: '600px',
        maxWidth: '600px',
      },
    },
  },
  rewestDialogTitle: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '16px 24px',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
  },
  closeIconButtonRewest: {
    height: '48px',
    width: '48px',
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  closeIconButtonRegular: {
    position: 'absolute',
    right: 0,
    top: 4,
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
}));

export default useStyles;
